import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FuseSharedModule } from '@fuse/shared.module';

import { SelectWithSearchComponent } from './select-with-search.component';

@NgModule({
  entryComponents: [
    SelectWithSearchComponent
  ],
  declarations: [
    SelectWithSearchComponent
  ],
  imports: [
    FuseSharedModule,

    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule
  ],
  exports: [
    SelectWithSearchComponent
  ]
})
export class SelectWithSearchModule { }
